import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import { createStyles, em, rem } from '@mantine/styles';
import { getSortedBreakpoints } from '../HorizontalSection/get-sorted-breakpoints/get-sorted-breakpoints.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useStyles = createStyles(function (theme, _ref) {
  var height = _ref.height,
      fixed = _ref.fixed,
      position = _ref.position,
      zIndex = _ref.zIndex,
      borderPosition = _ref.borderPosition,
      layout = _ref.layout;
  var breakpoints = _typeof(height) === "object" && height !== null ? getSortedBreakpoints(height, theme).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        breakpoint = _ref3[0],
        breakpointSize = _ref3[1];

    acc["@media (min-width: ".concat(em(breakpoint), ")")] = {
      height: rem(breakpointSize),
      minHeight: rem(breakpointSize)
    };
    return acc;
  }, {}) : null;
  return {
    root: __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues({}, theme.fn.fontStyles()), position), {
      zIndex: zIndex,
      left: layout === "alt" ? "var(--mantine-navbar-width, 0)" : 0,
      right: layout === "alt" ? "var(--mantine-aside-width, 0)" : 0,
      height: _typeof(height) === "object" ? rem(height == null ? void 0 : height.base) || "100%" : rem(height),
      maxHeight: _typeof(height) === "object" ? rem(height == null ? void 0 : height.base) || "100%" : rem(height),
      position: fixed ? "fixed" : "static",
      boxSizing: "border-box",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    }), breakpoints), {
      borderBottom: borderPosition === "bottom" ? "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]) : void 0,
      borderTop: borderPosition === "top" ? "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]) : void 0
    })
  };
});
export default useStyles;